module.exports = __webpack_public_path__ + "static/img/7.2786478f.png";